import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { Payment, AttachMoney } from '@mui/icons-material';
import api from '../../../services/api';

const PayoutModal = ({ open, onClose, campaign, onSuccess }) => {
  const [amount, setAmount] = useState(campaign?.amountRaised || 0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePayout = async () => {
    if (!campaign) return;
    setLoading(true);
    try {
      // API call to process payout
      await api.post(`/v1/api/admin/campaigns/${campaign.id}/payout`, { amount });
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to process payout');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ /* modal styling */ }}>
        <Typography variant="h6" gutterBottom>
          Process Payout for {campaign?.title}
        </Typography>
        
        <TextField
          label="Amount"
          type="number"
          fullWidth
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          InputProps={{
            startAdornment: <AttachMoney sx={{ mr: 1 }} />
          }}
          sx={{ mb: 2 }}
        />
        
        {error && <Typography color="error">{error}</Typography>}
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} /> : <Payment />}
            onClick={handlePayout}
            disabled={loading}
          >
            Confirm Payout
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PayoutModal;